import { Component, ViewEncapsulation, OnInit, TemplateRef, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { ColumnMode, SortType } from '@swimlane/ngx-datatable';
import { Page } from 'src/app/ui/datatable/page';
import { PaginationObject } from 'src/app/models/paginationObject';
import { SortObject } from 'src/app/models/sortObject';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { ExportToCsv } from 'export-to-csv';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { UserPersonSharedService } from 'src/app/services/shared/user/person/sharedPerson.service';
import { StringToDate } from 'src/app/utils/stringToDate';
import { ToastService } from 'src/app/services/toast.service';
import { copy2DArrayToClipboard } from 'src/app/utils/copy2DArrayToClipboard';
import { LoadingService } from 'src/app/services/shared/loading.service';
declare var gapi: any;

@Component({
  selector: 'apc-reports-dataset',
  templateUrl: './reports-dataset.component.html',
  styleUrls: ['./reports-dataset.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReportsDatasetComponent implements OnInit {
  SortType=SortType;
  // used on persona screens
  @ViewChild('tableReports', { static: true }) tableReports: TemplateRef<any>;
  @ViewChild('plainCell', { static: true }) plainCell: TemplateRef<any>;
  @ViewChild('numberCell', { static: true }) numberCell: TemplateRef<any>;
  @ViewChild('dateCell', { static: true }) dateCell: TemplateRef<any>;
  @ViewChild('translateCell', { static: true }) translateCell: TemplateRef<any>;
  @ViewChild('percentageCell', { static: true }) percentageCell: TemplateRef<any>;
  @ViewChild('currencyCell', { static: true }) currencyCell: TemplateRef<any>;
  @ViewChild('timeCell', { static: true }) timeCell: TemplateRef<any>;
  @ViewChild('greenEyeIconHomepage', { static: true }) greenEyeIconHomepage: TemplateRef<any>;
  @Input() public service: Function;
  @Input() public defaultColumns: [];
  @Input() public section: string;
  @Input() public subsection: string;
  @Input() public subsectionRoute: string = null;
  @Input() public enableFilter: boolean = true;
  @Input() public columnsToExclude: string[] = [];
  @Input() public isMultiForm: boolean = false;
  @Input() public columnsNotToFilter: string[] = [];
  @Input() public reportId: string;
  @Input() public reportName: string;
  iconsExpanded: boolean;
  public greenEyeTooltip: string;

  page = new Page();
  rows = new Array<any>();
  temp = [];
  columns = [];
  selectedTableColumns = [];
  columnsToDisplayInDropdown = [];
  data = {};

  rawEvent: any;
  contextmenuRow: any;
  contextmenuColumn: any;

  ColumnMode = ColumnMode;
  paginationObject = new PaginationObject();
  queryString = '';
  schema: any;
  pageDropDown = [5, 10, 20, 50, 100, 20000];
  pageElements: any = 10;

  @Input() sortArray: SortObject[];

  csvOptions: any = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: false,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
  };
  csvExporter = new ExportToCsv(this.csvOptions);
  columnsExist = false;
  showSearch = false;
  searchColumnUpdate = new Subject<any>();
  tableData = null;
  booleanValues = [
    { value: null, name: 'All' },
    { value: 'true', name: 'True' },
    { value: 'false', name: 'False' },
  ];
  hasNavigation: boolean = false;
  token: any;

  constructor(
    public http: HttpClient,
    public translate: TranslateService,
    public route: ActivatedRoute,
    public cdr: ChangeDetectorRef,
    public userPersonSharedService: UserPersonSharedService,
    public router: Router,
    public toastService: ToastService,
    public loadingService: LoadingService
  ) {}

  convertStringToDate(strDate: string) {
    return StringToDate(strDate);
  }

  generateInitialColumnsAndPagination(data) {
    this.columns = [];
    this.tableData = data.data.content;
    this.schema = data.schema;
    if (this.tableData.length > 0) {
      Object.keys(this.schema).forEach((key, index) => {
        this.columns.push({
          name: key,
          prop: key,
          //description: sch.description,
          cellTemplate: this.pickCellTemplate(this.schema[key], key),
          headerTemplate: this.translateCell,
          selected: false,
          width: 130,
        });
      });
      if (this.tableData[0] && this.tableData[0].system) {
        this.hasNavigation = true;
        this.columns.push({
          name: 'Navigation',
          prop: 'Navigation',
          cellTemplate: this.greenEyeIconHomepage,
          sortable: false,
          selected: false,
          width: 120,
        });
      }
      this.selectedTableColumns = this.columns;

      this.rows = this.tableData;

      this.page = {
        size: this.pageElements,
        totalElements: data.data.totalElements,
        totalPages: data.data.totalPages,
        pageNumber: 0,
      };
    }
    /* if (this.columnsToDisplayInDropdown?.length == 0 && this.columns.length > 0) {
      const defaultCheckedColumns = this.defaultColumns
        .map((elem: any) => {
          const baseColumn = this.columns.find((c: any) => c.name === elem.name);
          baseColumn.selected = true;
          return baseColumn;
        })
        .filter((col: any) => !columnsToBeExcluded.find((c) => col.name === c));
      const extraColumns = this.columns.filter(
        (column) => !columnsToBeExcluded.concat(defaultCheckedColumns.map((c) => c.name)).find((c) => column.name === c)
      );
      this.columnsToDisplayInDropdown = defaultCheckedColumns.concat(extraColumns);
    }*/
  }

  getRouteLink(detailId: string, subDetailId: string) {
    if (this.section === 'personas') {
      return `/persona/${detailId}`;
    } else if (this.subsection && subDetailId && this.isMultiForm) {
      return `/persona/${detailId}/${this.section}/${this.subsection}/${subDetailId}`;
    } else if (this.subsection) {
      return `/persona/${detailId}/${this.section}/${this.subsection}`;
    } else if (this.section == 'options') {
      return 'option/' + detailId;
    } else {
      return `/persona/${detailId}/${this.section}/${this.subsection}`;
    }
  }

  async ngOnInit() {
    await this.fetchData({ paginationObject: new PaginationObject(), sortArray: this.sortArray });
    this.columns = [...this.columns];
    this.selectTableColumns(this.columns);
  }

  async fetchData(data) {
    var result = await this.service(this.reportId, data.paginationObject, data.sortArray);
    this.generateInitialColumnsAndPagination(result);
  }

  ngAfterViewInit() {
    // moving footer inside the body so it has box shadow as per design
    var footer = document.getElementsByClassName('datatable-footer')[0];
    var body = document.getElementsByClassName('datatable-body')[0];
    if(typeof body != typeof undefined){
      body.appendChild(footer);
    }
  }

  setPage(pageInfo) {
    this.paginationObject = pageInfo;
    this.columnsExist = true;
    this.fetchData({ paginationObject: pageInfo, sortArray: this.sortArray });
  }

  setPageSize(event: any) {
    const value = event.target.value;
    let size;
    if (value === 'All') { // Se viene selezionato 'All', imposta size a 20000
      size = 20000;
    } else {
      size = Number(value);
    }
    let pagination = { pageSize: size, offset: 0, limit: size }
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    // this.offSet = 0;
    this.pageElements = size;
    this.page.pageNumber = this.paginationObject.offset;
    this.fetchData({ paginationObject: pagination, sortArray: this.sortArray, query: query });
  }

  onSort(event) {
    this.sortArray = event.sorts;
    let pagination = {
      count: 0,
      limit: this.pageElements,
      offset: 0,
      pageSize: this.pageElements
    }
    this.fetchData({ paginationObject: pagination, sortArray: event.sorts });
  }

  selectTableColumns(event, addNewColumn?: boolean) {
    var columnsToBeExcluded = [...this.columnsToExclude];
    /* if removing column */
    var duplicate;
    event.forEach((x) => {
      var count = 0;
      event.forEach((y) => {
        if (x.name == y.name) {
          count++;
          if (count > 1) duplicate = x;
        }
      });
    });

    if (duplicate) {
      _.remove(event, {
        name: duplicate.name,
      });
      this.columns.forEach((element) => {
        if (element.name == duplicate.name) {
          element.selected = false;
        }
      });
    }
    /* removing colum end */

    /* order columns by default order from the backend */

    this.selectedTableColumns = [];
    this.columnsToDisplayInDropdown = this.columns;
    let sortedEventArray = this.columns.map((el) => {
      return event.find((eventEl) => eventEl.name === el.name);
    });
    sortedEventArray = sortedEventArray.filter((el) => el !== undefined);
    sortedEventArray = sortedEventArray.length == 0 ? event : sortedEventArray;
    /* order columns by default order from the backend end*/
    sortedEventArray.forEach((el) => {
      this.columns.forEach((element) => {
        if (element.name == el.name) {
          element.selected = true;
        }
      });
      if (el.name !== 'Navigation' && !columnsToBeExcluded.find((e) => e === el.name)) {
        this.selectedTableColumns.push({
          name: el.name,
          prop: el.name,
          searchValue: el.searchValue,
          //description: this.schema.find((sch) => sch.name === el.name).description,
          //cellTemplate: this.pickCellTemplate(this.schema.find((sch) => sch.name === el.name).type, el.name),
          cellTemplate: this.pickCellTemplate(this.schema[el.name], el.name),
          headerTemplate: this.translateCell,
          selected: false,
          width: 130,
        });
      }
    });
    if (this.tableData[0] && this.tableData[0].system) {
      this.hasNavigation = true;
      this.selectedTableColumns.push({
        name: 'Navigation',
        prop: 'Navigation',
        cellTemplate: this.greenEyeIconHomepage,
        sortable: false,
        selected: false,
        width: 120,
      });
    }

    // remove fitler, custom id and persona name from dropdown
    this.columnsToDisplayInDropdown = this.columnsToDisplayInDropdown.filter(
      (column: any) => !columnsToBeExcluded.find((c) => column.name === c)
    );
    if (addNewColumn && !duplicate) {
      this.refreshData();
    }
  }

  selectAllColumns() {
    this.selectTableColumns(this.columns);
  }

  unselectAllColumns() {
    const columnsToKeep = this.columns.filter(
      (col) => col.name == 'status' || col.name == 'identificationCodeMnemonic' || col.name == 'personaName'
    );

    this.selectedTableColumns.forEach((col) => {
      this.selectTableColumns([col, ...columnsToKeep]);
    });
    this.columns.forEach((col) => (col.selected = false));
  }

  async exportCSV() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';

    let result = await this.service(this.reportId, { pageSize: this.page.totalElements }, this.sortArray);
    const columns = this.selectedTableColumns;

    const data = result.data;
    // we want export only data that is shown in the selected columns
    const dataForExport = data.content.map((o) =>
      columns.reduce((acc, curr) => {
        if (curr.name !== 'Navigation') {
          let translatedColumnName: any = this.translate.instant(curr.name);
          acc[translatedColumnName] = o[curr.name] ? o[curr.name] : '';
        }
        return acc;
      }, {})
    );

    this.csvExporter.options.filename = this.reportName + '-' + moment().toISOString();

    this.csvExporter.generateCsv(dataForExport);
    document.getElementById('close-export-dropdown').click();
  }

  async refreshData() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    let pagination = {
      count: 0,
      limit: this.pageElements,
      offset: 0,
      pageSize: this.pageElements
    }
    await this.fetchData({ paginationObject: pagination, sortArray: this.sortArray });
  }

  arraymove(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }

  addNewColumn(event) {
    this.selectTableColumns(event, true);
  }

  pickCellTemplate(schemaKey: string, columnName: string) {
    switch (schemaKey) {
      case 'percentage':
        return this.percentageCell;
      case 'time':
        return this.timeCell;
      case 'TIMESTAMP':
        return this.dateCell;
      case 'currency':
        return this.currencyCell;
      case 'STRING':
      case 'boolean':
        return this.plainCell;
      case 'INTEGER':
        return this.numberCell;
      default:
        if (columnName !== 'identifier')
          console.warn('Found ' + columnName + ' which is not in schema. Defaulting to text input.');
        return this.plainCell;
    }
  }

  navigateTo(url) {
    var isAbsolute = new RegExp('^([a-z]+://|//)', 'i');
    if (!isAbsolute.test(url)) {
      window.open(url, '_blank');
    } else {
      window.open(url, '_blank');
    }
  }

  async copyToClipboard() {
    let query = this.queryString.length > 0 ? '&query=' + encodeURIComponent(this.queryString) : '';
    let result = await this.service(this.reportId, { pageSize: this.page.totalElements }, this.sortArray);
    const columns = this.selectedTableColumns;
    const data = result.data;
    // we want export only data that is shown in the selected columns
    const dataForExport = data.content.map((o) =>
      columns.reduce((acc, curr) => {
        if (curr.name !== 'Navigation') {
          let translatedColumnName: any = curr.name;
          acc[translatedColumnName] = o[curr.name] ? o[curr.name] : '';
        }
        return acc;
      }, {})
    );
    navigator.clipboard.writeText(copy2DArrayToClipboard(dataForExport)).then(() => {
      this.toastService.showSuccess('Copied to Clipboard!');
      document.getElementById('close-export-dropdown').click();
    });
  }

  async exportSheet() {
    let result = await this.service(this.reportId, { pageSize: this.page.totalElements }, this.sortArray);
    const columns = this.selectedTableColumns;
    const data = result.data;

    var spreadsheetBody = {
      properties: {
        title: this.reportName + '-' + moment().toISOString(),
      },
      sheets: [
        {
          //sheet1
          properties: {
            title: 'Sheet1',
            gridProperties: {
              columnCount: columns.find((el) => el.name === 'Navigation') ? columns.length - 1 : columns.length,
              rowCount: data.length + 1,
              frozenRowCount: 1,
            },
            tabColor: {
              red: 1.0,
              green: 0.3,
              blue: 0.4,
            },
          },
        },
      ],
    };
    this.loadingService.pushLoadingRequests('sheets api');
    // first we create the spreadsheet
    this.token.callback=(resp)=>{
      if (resp.error !== undefined) {
        console.error("TOKEN",resp);
        throw(resp);
      }
      gapi.client.sheets.spreadsheets
      .create(() => {}, spreadsheetBody)
      .then(
        (response) => {
          // we want export only data that is shown in the selected columns
          const dataForExport = data.content.map((o) =>
            columns.reduce((acc, curr) => {
              if (curr.name !== 'Navigation') {
                let translatedColumnName: any = this.translate.instant(curr.name);
                acc[translatedColumnName] = o[curr.name] ? o[curr.name].toString() : '';
              }
              return acc;
            }, {})
          );
          var sheetDataArray = [];
          let columnArray = [];
          columns.forEach((col) => {
            if (col.name !== 'Navigation') columnArray.push(col.name);
          });
          sheetDataArray.push(columnArray);
          let dataArray = dataForExport.map(Object.values);
          dataArray.forEach((data) => {
            sheetDataArray.push(data);
          });
          // when sheet created we update it with data
           //@ts-ignore
          gapi.client.sheets.spreadsheets
            .batchUpdate(
              {
                spreadsheetId: response.result.spreadsheetId,
              },
              {
                requests: [
                  {
                    pasteData: {
                      coordinate: {
                        sheetId: response.result.sheets[0].properties.sheetId,
                        rowIndex: 0,
                        columnIndex: 0,
                      },
                      data: copy2DArrayToClipboard(dataForExport),
                      type: 'PASTE_NORMAL',
                      delimiter: '\t',
                    },
                  },
                  {
                    autoResizeDimensions: {
                      dimensions: {
                        sheetId: response.result.sheets[0].properties.sheetId,
                        dimension: 'COLUMNS',
                        startIndex: 0,
                        endIndex: columns.find((el) => el.name === 'Navigation') ? columns.length - 1 : columns.length,
                      },
                    },
                  },
                  {
                    addBanding: {
                      bandedRange: {
                        range: {
                          sheetId: response.result.sheets[0].properties.sheetId,
                          startRowIndex: 0,
                          endRowIndex: data.length + 1,
                          startColumnIndex: 0,
                          endColumnIndex: columns.find((el) => el.name === 'Navigation') ? columns.length - 1 : columns.length,
                        },
                        rowProperties: {
                          firstBandColor: {
                            red: 1,
                            green: 1,
                            blue: 1,
                            alpha: 0,
                          },
                          secondBandColor: {
                            red: 0.90,
                            green: 0.90,
                            blue: 0.90,
                            alpha: 1,
                          },
                        },
                      },
                    },
                  },
                  {
                    repeatCell: {
                      range: {
                        sheetId: response.result.sheets[0].properties.sheetId,
                        startRowIndex: 0,
                        endRowIndex: 1
                      },
                      cell: {
                        userEnteredFormat: {
                          textFormat: {
                            bold: true,
                          },
                        },
                      },
                      fields: 'userEnteredFormat.textFormat.bold',
                    },
                  }
                ],
              }
            )
            .then(
              () => {
                this.toastService.showSuccess(
                  `Spreadsheet export is completed, click <a target='_blank' style="color: white !important; font-weight: bold;" href='${response.result.spreadsheetUrl}'>here</a> to open the file`,
                  10000
                );
                var win = window.open(response.result.spreadsheetUrl, '_blank')
                if(win) {
                  win.focus();
                }
                this.loadingService.popLoadingRequests();
                document.getElementById('close-export-dropdown').click();
              },
              (err) => {
                this.loadingService.popLoadingRequests();
                this.toastService.showError('Something happened');
                console.log(err);
                document.getElementById('close-export-dropdown').click();
              }
            );
        },
        (reason) => {
          this.loadingService.popLoadingRequests();
          this.toastService.showError('Something happened');
          console.log(reason);
          document.getElementById('close-export-dropdown').click();
        }
      );
    }

    if (gapi.client.getToken() === null) {
      // Prompt the user to select a Google Account and asked for consent to share their data
      // when establishing a new session.
      this.token.requestAccessToken({prompt: 'consent'});
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      this.token.requestAccessToken({prompt: ''});
    }


  }

  setToken(tk:any){
    this.token=tk;
  }
}
